import { gql } from "@apollo/client";

export default gql`
  mutation signup(
    $branch: String
    $foundationId: String
    $username: String
    $password: String
    $phone: String
    $roles: String
    $newroles: String
    $title: String
    $name: String
    $email: String
    $avatar: String
    $department: DepartmentInput
    $employee: EmployeeInput
    $isBranchsAdmin: Boolean
    $isBranchAdmin: Boolean
    $isAccountant: Boolean
    $isDepartAdmin: Boolean
    $isEmployee: Boolean
    $isFinance: Boolean
    $isOperate: Boolean
    $isPurchase: Boolean
    $isAdmin: Boolean
    $isEditor: Boolean
    $isWriter: Boolean
    $isViewer: Boolean
    $themeId: Int
  ) {
    signup(
      branch: $branch
      foundationId: $foundationId
      username: $username
      password: $password
      phone: $phone
      roles: $roles
      newroles: $newroles
      title: $title
      name: $name
      email: $email
      avatar: $avatar
      department: $department
      employee: $employee
      isBranchsAdmin: $isBranchsAdmin
      isBranchAdmin: $isBranchAdmin
      isAccountant: $isAccountant
      isDepartAdmin: $isDepartAdmin
      isEmployee: $isEmployee
      isFinance: $isFinance
      isOperate: $isOperate
      isPurchase: $isPurchase
      isAdmin: $isAdmin
      isEditor: $isEditor
      isWriter: $isWriter
      isViewer: $isViewer
      themeId: $themeId
    ) {
      ok
      message
      data {
        _id
        branch
        branchs
        foundationId
        type
        username
        name
        email
        phone
        avatar
        address
        color
        lang
        tel
        fax
        mob

        billactive
        maxbranches

        roles
        newroles
        title

        publicKey

        isBranchsAdmin
        isBranchAdmin
        isAccountant
        isDepartAdmin
        isEmployee
        isFinance
        isOperate
        isPurchase
        isAdmin
        isEditor
        isWriter
        isViewer

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeePhone
        employeeColor

        stockId
        stockName
        stockNameAr

        verified
        payverified
        block
        themeId

        userId

        createdAt
        updatedAt
      }
      accessToken
      refreshToken
      hasCompany
      error
    }
  }
`;
